import React, { useMemo } from 'react';
import { Button, Flex, IconArrowLeftOutline } from '@zillow/constellation';
import { useCustomViewsContext } from '../../context/CustomViewsContext';
import { useLocation } from 'react-router-dom';
import {
  checkForExistingShortcutSearchString,
  useGetCustomViewsQuery,
} from '../../../../../../API/pcDashboard/CustomViewsApi';

const useAlreadySaved = () => {
  const { search } = useLocation();
  const { data = {} } = useGetCustomViewsQuery();
  return useMemo(() => checkForExistingShortcutSearchString(search, data), [search, data]);
};

export const EditFooter: React.FC = () => {
  const isAlreadySaved = useAlreadySaved();
  const { setCustomViewsState } = useCustomViewsContext();
  return (
    <Flex display={'flex'} flexDirection={'row-reverse'} gap={'xs'} alignItems={'center'}>
      <Button
        disabled={isAlreadySaved}
        buttonType={'primary'}
        type={'button'}
        onClick={() =>
          setCustomViewsState({
            isOpen: true,
            isEdit: true,
            updatingView: null,
            isCreate: true,
            formikData: { dirty: false, isValid: false },
          })
        }
      >
        {isAlreadySaved ? 'Saved view' : 'Create new view'}
      </Button>
      <Button
        icon={<IconArrowLeftOutline />}
        buttonType={'secondary'}
        onClick={() =>
          setCustomViewsState((prev) => ({
            ...prev,
            updatingView: null,
            isCreate: false,
            isEdit: false,
            formikData: null,
          }))
        }
        type={'button'}
      >
        Back
      </Button>
    </Flex>
  );
};
